export default __webpack_public_path__ + "static/media/cacib.02691150.svg";